import { create } from 'zustand';
import { currentUser, isAuthenticated, type AuthUser } from '@/auth/authClient';

interface AuthState {
  user: AuthUser | null;
  authed: boolean;
  // Re-read tokens from sessionStorage after login/logout so UI reacts.
  syncFromStorage: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: currentUser(),
  authed: isAuthenticated(),
  syncFromStorage: () => set({ user: currentUser(), authed: isAuthenticated() }),
}));
